module.exports = __webpack_public_path__ + "static/menu-logo-9c2b1b5f9babaf611ae8b37533f15a99.jpg";